import React from 'react';
import SectionHeading from './SectionHeading';
import { integrations } from '../mock/mock';

// Real brand logos via Simple Icons CDN with graceful monogram fallback.
function PlatformLogo({ item }) {
  const [failed, setFailed] = React.useState(!item.slug);
  return (
    <div className="group relative glass rounded-2xl h-28 grid place-items-center px-4 hover:border-[#2563eb]/45 hover:-translate-y-1 transition-all">
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-[#2563eb]/0 to-[#1d4ed8]/0 group-hover:from-[#2563eb]/8 group-hover:to-[#1d4ed8]/8 transition-colors" />
      <div className="relative flex flex-col items-center gap-2.5">
        {!failed ? (
          <img
            src={`https://cdn.simpleicons.org/${item.slug}/64748b`}
            alt={item.name}
            className="h-8 w-8 object-contain opacity-80 group-hover:opacity-100 transition-opacity"
            loading="lazy"
            onError={() => setFailed(true)}
          />
        ) : (
          <span className="w-9 h-9 rounded-lg bg-blue-50 border border-blue-100 grid place-items-center font-display font-bold text-blue-700 text-sm">
            {item.name.split(' ').map((w) => w[0]).join('').slice(0, 2)}
          </span>
        )}
        <span className="text-xs font-medium text-slate-600 text-center whitespace-nowrap">{item.name}</span>
      </div>
    </div>
  );
}

export default function IntegrationsSection() {
  return (
    <section className="relative max-w-7xl mx-auto px-5 md:px-8 section-pad">
      <SectionHeading
        eyebrow="Integrations & Platforms"
        title={<span>Plugged into the <span className="text-gradient">performance ecosystem.</span></span>}
        subtitle="We work across leading measurement, attribution and advertising platforms to track and optimize every campaign."
      />
      <div className="reveal grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {integrations.map((p) => (<PlatformLogo key={p.name} item={p} />))}
      </div>
      <p className="reveal text-center text-xs text-slate-600 mt-6">Platform logos shown for reference — no official partnership is implied unless verified.</p>
    </section>
  );
}
